const GET_WALLET_DATA = 'GET_WALLET_DATA';

const AUTH_TYPES = {
	GET_WALLET_DATA,
};

export default AUTH_TYPES;
